/**
 * Centralized path constants so route strings aren't duplicated/hardcoded
 * across pages, links, and redirects.
 */
export const ROUTES = {
  home: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  ssoCallback: "/sso-callback",
  items: "/items",
  notFound: "*",

  // Finance / governance portal
  financeDashboard: "/finance/dashboard",
  financeAnnualSummary: "/finance/annual-summary",
  financeBudgets: "/finance/budgets",
  financeActuals: "/finance/actuals",
  financeBudgetVsActual: "/finance/budget-vs-actual",
  financeMonthlyAnalysis: "/finance/monthly-analysis",
  financeForecast: "/finance/forecast",
  financeRevenue: "/finance/revenue",
  financeCashFlow: "/finance/cash-flow",
  financePnl: "/finance/pnl",
  financeDepartmentBudget: "/finance/department-budget",
  financeCostCentreBudget: "/finance/cost-centre-budget",
  financeTallyImport: "/finance/tally-import",
  financeApprovals: "/finance/approvals",
  financePeriodControl: "/finance/period-control",
  financeVersions: "/finance/versions",
  financeAuditTrail: "/finance/audit-trail",
  financeUsers: "/finance/users",
  financeRoles: "/finance/roles",
  financeReports: "/finance/reports",
  financeSettings: "/finance/settings",
} as const;
